import React, { Fragment, PureComponent, createRef } from 'react';

import { withEventState } from 'src/ver2/pages/event/context';
import { InfoAdder, InfoChanger } from 'src/ver2/components/trefaText/adders';

import Loader from 'src/ver2/components/loader';
import ButtonPlashka from 'src/ver2/plashki/ui/button';
import { Tabs, Button } from 'antd';
import templates from './templates';

import './style.css';

const TabPane = Tabs.TabPane;

const USUAL_DISCRIPTIONS = {
    'payment': 1
}

const COMPETITION_DISCRIPTIONS = {
    'payment': 1,
    'insurance': 1,
    "medicine": 1,
}

class DiscriptionManager extends PureComponent {

    constructor(props) {
        super(props)
        this.refTrefaText = createRef();
    }

    state = {
        loading: false,
    }

    render() {

        const { DiscriptionTab } = this;
        const { Event, isDiscriptionsReady, Discriptions } = this.props;
        const { loading } = this.state;

        if (!Event || !isDiscriptionsReady) return <div className='championship_manager_component'>
            <Loader text='Гружу данные' />
        </div>

        const { Type } = Event;
        console.log('Discriptions', Discriptions)

        let discriptionTypes = {}

        if (Type !== 'championship') {
            discriptionTypes = USUAL_DISCRIPTIONS
        } else {
            discriptionTypes = COMPETITION_DISCRIPTIONS;
        }

        if (Discriptions && Discriptions.length) {
            for (let i = 0; i < Discriptions.length; i++) {
                const { Type: discType } = Discriptions[i];
                if (discType === 'info') continue;
                if (!discriptionTypes[discType]) {
                    discriptionTypes[discType] = 1;
                }
            }
        }

        return <div>
            <Tabs className='admin_modal_tabs' tabPosition='top'>
                {Object.keys(discriptionTypes).map(discType => {
                    return <TabPane tab={discType} key={discType}>
                        <DiscriptionTab discType={discType} />
                    </TabPane>
                })}
            </Tabs>
        </div>
    }

    DiscriptionTab = ({ discType }) => {

        const { Discriptions, addDiscriptionType, updateDiscriptionType } = this.props;
        const discription = Discriptions.find(x => x.Type === discType);

        const addDiscription = async (data) => {
           await addDiscriptionType(data, discType);
        }
        const updateDiscription = async (data) => {
           await updateDiscriptionType(data, discription.Id);
        }

        return <div>

            <div className='discriptions_buttons_row'>
                {templates[discType] && Object.keys(templates[discType]).map(key => {
                    return <Button key = {key} onClick={() => {
                        this.refTrefaText.current.setText(templates[discType][key]);
                    }}>
                        {key}
                    </Button>

                })}
            </div>

            {discription ?
                <InfoChanger settedRef={this.refTrefaText} text={discription.Body} onCallback={updateDiscription} /> :
                <InfoAdder settedRef={this.refTrefaText} onCallback={addDiscription} />
            }
        </div>
    }

}


export default withEventState(
    `
    Event,
    Championship,
    Discriptions,
    isDiscriptionsReady,
    iamuser,
    client,
    addDiscriptionType,
    updateDiscriptionType,
    `
)(DiscriptionManager)